import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function selectionListRequiredValidator(values:any[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!values?.length && !control.value?.length) return { selectionListRequired: false };
    return null;
  };
}
